<template>
  
  <div class="row border-bottom">
    <div class="col-md-4">
      <img :src="cart.product.image_url" class="card-img" :alt="cart.product.name">
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title mb-5 mt-4">Nama Barang : {{cart.product.name}}</h5>
        <p class="card-text">Jumlah : {{cart.quantity}}</p>
        <p class="card-text"><small class="text-muted">Harga : Rp.{{cart.product.price}}</small></p>
        <button @click="deleteCart(cart.id)" class="btn btn-outline-danger">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'ListCard',
    props: ['cart'],
    methods : {
      deleteCart (id) {
        console.log(id);
        this.$store.dispatch('deleteCart',id)
      }
    }
}
</script>

<style>

</style>